import Box from '../../../../Global/Box'
import {
  findArrayStatus,
  fnObjNameStatus,
} from '../../../../../const/constStatuses'
import GetAverageTimeByStatusIdItem from './GetAverageTimeByStatusIdItem'
import { useState } from 'react'

const objNameStatus = fnObjNameStatus()
const st_pendiente = findArrayStatus(objNameStatus.pendiente)
const st_planificar = findArrayStatus(objNameStatus.planificar)
const st_procesar = findArrayStatus(objNameStatus.procesar)
const st_asignar = findArrayStatus(objNameStatus.asignar)
const st_validacion_inicial = findArrayStatus(objNameStatus.validacion_inicial)
const st_validacion_final = findArrayStatus(objNameStatus.validacion_final)
const st_completado = findArrayStatus(objNameStatus.completado)

const GetAverageTimeByStatusId = ({ filters }) => {
  //STATES
  const [existResult, setExistResult] = useState(false)

  return (
    <Box
      classNameHeader="card-header py-1 bg-info"
      contentHeader={
        <h3 className="card-title pl-3 mt-0">
          <div className="text-white">
            <i className={`fas fa-exchange-alt pr-2`} />
            Tiempo promedio cambio de estatus
          </div>
        </h3>
      }
      classCardBody="card-body m-0 p-3"
      content={
        <>
          {!existResult && (
            <div className="alert alert-default-info p-1">
              No hay resultados
            </div>
          )}

          <div className="d-flex flex-wrap justify-content-start align-items-start">
            <GetAverageTimeByStatusIdItem
              startStatus={st_pendiente}
              endStatus={st_planificar}
              filters={filters}
              setExistResult={setExistResult}
            />
            <GetAverageTimeByStatusIdItem
              startStatus={st_planificar}
              endStatus={st_procesar}
              filters={filters}
              setExistResult={setExistResult}
            />
            <GetAverageTimeByStatusIdItem
              startStatus={st_pendiente}
              endStatus={st_procesar}
              filters={filters}
              setExistResult={setExistResult}
            />
            <GetAverageTimeByStatusIdItem
              startStatus={st_procesar}
              endStatus={st_asignar}
              filters={filters}
              setExistResult={setExistResult}
            />
            <GetAverageTimeByStatusIdItem
              startStatus={st_asignar}
              endStatus={st_validacion_inicial}
              filters={filters}
              setExistResult={setExistResult}
            />
            <GetAverageTimeByStatusIdItem
              startStatus={st_validacion_inicial}
              endStatus={st_validacion_final}
              filters={filters}
              setExistResult={setExistResult}
            />
            <GetAverageTimeByStatusIdItem
              startStatus={st_validacion_final}
              endStatus={st_completado}
              filters={filters}
              setExistResult={setExistResult}
            />
          </div>
        </>
      }
    />
  )
}

export default GetAverageTimeByStatusId
